"use client"

import * as React from "react"
import { Moon, Sun, Cloud, Sparkles } from "lucide-react"
import { useTheme } from "next-themes"
import { Button } from "@/components/ui/button"
import { triggerHaptic } from "@/hooks/use-platform"
import { cn } from "@/lib/utils"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = React.useState(false)

  React.useEffect(() => {
    setMounted(true)
  }, [])

  const toggleTheme = () => {
    triggerHaptic('impact')
    setTheme(theme === "light" ? "dark" : "light")
  }

  if (!mounted) {
    return (
      <div className="w-10 h-10 md:w-12 md:h-12 rounded-2xl bg-slate-100 dark:bg-slate-800 animate-pulse" />
    )
  }

  return (
    <button
      onClick={toggleTheme}
      className={cn(
        "relative w-10 h-10 md:w-12 md:h-12 rounded-2xl flex items-center justify-center transition-all duration-500 overflow-hidden group",
        "bg-slate-100/50 dark:bg-slate-800/50 hover:bg-white dark:hover:bg-slate-700",
        "border border-slate-200/50 dark:border-slate-700 shadow-sm active:scale-90"
      )}
    >
      {/* Dynamic Background */}
      <div className={cn(
        "absolute inset-0 transition-opacity duration-500",
        theme === "light" ? "bg-blue-50 opacity-100" : "bg-indigo-900/40 opacity-0"
      )} />
      
      <div className="relative z-10">
        {theme === "light" ? (
          <Sun className="h-5 w-5 text-amber-500 fill-amber-500 animate-in zoom-in spin-in-90 duration-500" />
        ) : (
          <Moon className="h-5 w-5 text-indigo-300 fill-indigo-300 animate-in zoom-in spin-in-90 duration-500" />
        )}
      </div>

      {/* Decorative elements */}
      {theme === "light" ? (
        <Cloud className="absolute -bottom-1 -right-1 w-4 h-4 text-blue-200/50 group-hover:translate-x-1 transition-transform" />
      ) : (
        <Sparkles className="absolute top-1 right-1 w-3 h-3 text-indigo-200/30 group-hover:scale-125 transition-transform" />
      )}
      
      <span className="sr-only">Toggle theme</span>
    </button>
  )
}
